import * as THREE from "three"
import gsap from "gsap"
import Base from "./base";
export default class ModelBase extends Base {
    constructor(parent) {
        super();

        var self = this;
        
        this._name = "ModelBase";

        this._popup = {
            menus: {
                edit: {
                    title: '수정',
                    class: 'modify',
                    event: function() {
                        if(self._simulator) {
                            self._simulator._onModelEditByPopup(self);
                        }
                    }
                },
                delete: {
                    title: '삭제',
                    class: 'delete',
                    event: function() {
                        if(self._simulator) {
                            self._simulator._onModelDeleteByPopup(self);
                        }
                        
                        self.delete();
                    }
                }
            }
        }

        this._size = null;

        this._parent = parent;
        this._simulator = parent && parent._simulator ? parent._simulator : null;
        this._model = null;
    }

    // setParent
    setParent(parent) {
        this._parent = parent;
    }

    // Size

    setSize(size) {
        this.size(size);
    }

    getSize() {
        return this.size();
    }

    size(size) {
        if(typeof(size) !== 'undefined') {
            this._size = size;
        } else {
            return this._size;
        }
    }

    zoom(fitOffset = 1.4, toPosition = null, animate = true) {
        const camera = this._simulator._camera, 
              controls = this._simulator._controls; 
        
        const size = new THREE.Vector3();
        const center = new THREE.Vector3();
        const box = new THREE.Box3();

        if(toPosition === null) {
            toPosition = camera.position.clone()
        }
        
        box.makeEmpty();
        box.expandByObject(this._model);
        
        box.getSize(size);
        box.getCenter(center);
        
        const maxSize = Math.max(size.x, size.y, size.z);
        const fitHeightDistance = maxSize / (2 * Math.atan(Math.PI * camera.fov / 360));
        const p = this._simulator._canvas.width / (this._simulator._canvas.height);
        const fitWidthDistance = fitHeightDistance / camera.aspect * p;
        const h = fitWidthDistance / p;
        const distance = fitOffset * Math.max(fitHeightDistance, fitWidthDistance, h);
        
        const direction = controls.target.clone()
        .sub(toPosition)
        .normalize()
        .multiplyScalar(distance);

        // controls.maxDistance = distance * 10;
        controls.target.copy(center);
        
        camera.near = distance / 100;
        camera.far = distance * 100;
        camera.updateProjectionMatrix();
        
        toPosition.copy(controls.target).sub(direction);

        if(this._timeline) {
            this._timeline.pause();
            this._timeline = null;
        }

        if(animate) {
            var timeline = gsap.timeline({
                onUpdate: () => {
                    controls.update();
                },
                onComplete: () => {
                    controls.update();
                    this._timeline = null;
                }
            });
            
            timeline.to(
                camera.position,
                {
                    x: toPosition.x,
                    y: toPosition.y,
                    z: toPosition.z, 
                    duration: 1,
                    ease: 'expo'
                });
            timeline.to(
                controls.position,
                {
                    x: center.x,
                    y: center.y,
                    z: center.z, 
                    duration: 1,
                    ease: 'expo'
                });

            this._timeline = timeline;
        } else {
            camera.position.copy(toPosition);
            // controls.position.copy(center);
            controls.update();
        }
    }

    click() { 
        this._popup.position = this.getScreenPosition();
        this._simulator.viewPopup(this._popup);

        this.trigger('click');
    }

    // Action
    delete() {
       this._delete();
       this.trigger('delete');
    }

    _delete() {
        if(this._model) {
            if(this._model.geometry) this._model.geometry.dispose();
            if(this._model.material) this._model.material.dispose();
            if(this._model.texture) this._model.texture.dispose();

            this._simulator.removeFromScene(this._model);

            delete this._model;
            this._model = null
        }
    }

    getModel() {
        return this._model;
    }

    getModelBound() {
        if(this._model) {
            const modelBound = new THREE.Box3().setFromObject(this._model);
            return modelBound;
        }
        
        return false;
    }

    getType() {
        if(this._name) return this._name.toLowerCase();
        return false;
    }

    getModelSize() {
        if(this._model) {
            const modelSize = new THREE.Box3().setFromObject(this._model);
            return modelSize.getSize(new THREE.Vector3());
        }
        
        return false;
    }

    setSimulator(simulator) {
        this._simulator = simulator
    }
    
    addToScene(scene) {
        if(this._model) scene.add(this._model);
    }

    // 오브젝트(모델)의 루트 오브젝트로
    _getParentObject(object) {
        const parent = object.parent;

        if(parent && parent.type !== 'Scene') {
            return this._getParentObject(parent);
        }
        return object;
    }

    // 오브젝트(모델)의 루트 모델로 (의자 등)
    _getParentModel(object) {
        if(object = this._getParentObject(object)) {
            return object.__parent ? object.__parent : null;
        }

        return null;
    }


    // 오브젝트의 위치를 HTML 위치로
    _toScreenPosition(obj) {
        if(!this._simulator) return null;

        const renderer = this._simulator._renderer;
        const camera = this._simulator._camera;

        let vector = new THREE.Vector3();

        var canvasHalfWidth = renderer.domElement.offsetWidth / 2;
        var canvasHalfHeight = renderer.domElement.offsetHeight / 2;
        
        obj.updateMatrixWorld();
        vector.setFromMatrixPosition(obj.matrixWorld);

        var modelSize = this.getModelSize();
        vector.y += modelSize.y/2; // y의 반 높이만큼 올리기

        vector.project(camera);

        vector.x = (vector.x * canvasHalfWidth) + canvasHalfWidth + renderer.domElement.offsetLeft;
        vector.y = -(vector.y * canvasHalfHeight) + canvasHalfHeight + renderer.domElement.offsetTop;

        return vector;
    }

    getScreenPosition() {
        if(this._model) {
            return this._toScreenPosition(this._model)
        }

        return false;
    }
}